import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminMlpsMlpRoute extends Route {
  // Services
  @service breadcrumb;
  @service pageBuilderFrontendApi;
  @service store;

  // Hooks
  async model({ mlp_id }) {
    const { content } = await this.store.request(findRecord('mlp', mlp_id));

    return content.data;
  }

  afterModel(model) {
    this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      model,
    );
    this.breadcrumb.registerDetailRoute(model);
  }
}
